module.exports = __webpack_public_path__ + "static/img/Heavy_Snow.f58478ae.png";